<template>
  <div>
    <Dialog
      width="680px"
      :height="createRenderType == 'pc' ? '' : ''"
      :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
      :customClass="`${createRenderType}-upgrade-dialog upgrade-dialog`"
      titleAlign="left"
      :visible="dialogVisible"
      @close="onClose"
    >
      <div>
        <div class="title">
          {{ upgradeDialogData.new_product?.level_name == "pro" ? $t("credit.switch_to_pro_plan") : $t("credit.switch_to_basic_plan") }}
        </div>
        <div class="info-box">
          <div class="info-item">
            <div class="text">{{ $t("credit.from_plan", { plan: upgradeDialogData?.cur_product?.title }) }}</div>
            <div class="price">{{ mathCurPrice() }}</div>
          </div>
          <div class="info-item">
            <div class="text">{{ $t("credit.to_plan", { plan: upgradeDialogData?.new_product?.title }) }}</div>
            <div class="price">{{ mathNewPrice() }}</div>
          </div>
          <div class="stripe-info" v-if="upgradeDialogData.new_product.channel != 'paypal'">
            <div class="line"></div>
            <div class="time">{{ `${moment().format("MM/DD/YYYY")} - ${moment(upgradeDialogData?.period_end * 1000).format("MM/DD/YYYY")}` }}</div>
            <div class="info-item">
              <div class="text">
                {{ $t("credit.remaining_time_on", { plan: upgradeDialogData.new_product?.title, time: moment().format("MM/DD/YYYY") }) }}
              </div>
              <div class="price">{{ `${upgradeDialogData.currency_symbol} ${(upgradeDialogData?.new_price_money / 100).toFixed(2)}` }}</div>
            </div>
            <div class="info-item">
              <div class="text">
                {{ $t("credit.unused_time_on", { plan: upgradeDialogData.cur_product?.title, time: moment().format("MM/DD/YYYY") }) }}
              </div>
              <div class="price">{{ `${upgradeDialogData.currency_symbol} ${(upgradeDialogData?.unused_money / 100).toFixed(2)}` }}</div>
            </div>
            <div class="line"></div>

            <div v-if="upgradeDialogData.percent_off" class="info-item">
              <div class="text">
                {{ $t("credit.discount") }}
              </div>
              <div class="price">
                {{ $t("credit.discountoff", { price: `${upgradeDialogData.percent_off}%` }) }} &nbsp; {{upgradeDialogData.currency_symbol}} -{{
                  ((upgradeDialogData?.total_money * upgradeDialogData.percent_off) / 10000).toFixed(2)
                }}
              </div>
            </div>

            <div class="info-item big-text">
              <div class="text">{{ $t("credit.amount_due") }}</div>
              <div class="price" v-if="upgradeDialogData.percent_off">
                <span class="discount-text">{{upgradeDialogData.currency_symbol}} {{ (upgradeDialogData?.total_money / 100).toFixed(2) }}</span>
                <span>{{upgradeDialogData.currency_symbol}} {{ ((upgradeDialogData?.total_money * (100 - upgradeDialogData.percent_off)) / 10000).toFixed(2) }}</span>
              </div>
              <div class="price" v-else>{{upgradeDialogData.currency_symbol}} {{ (upgradeDialogData?.total_money / 100).toFixed(2) }}</div>
            </div>
          </div>

          <div v-else class="paypal-text">{{ $t("credit.please_note_that") }}</div>

          <div class="paypal-button-box" v-if="upgradeDialogData.new_product.channel == 'paypal'">
            <div id="paypal-button-container"></div>
          </div>
          <div v-else class="Upgrade-button pointer" :class="{ 'is-loading': handleLoading }" @click="handleUpgrade(upgradeDialogData?.new_product)">
            <div class="common">{{ $t("credit.confirm_plan_switch") }}</div>
            <div class="loading"></div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, watch, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import { upgrade } from "@/api/api/apiCredit.js";
import { $$language, $$t } from "@/i18n/i18n.js";
import { loadScript } from "@paypal/paypal-js";
import { useRouter, useRoute } from "vue-router";
import GlobalConfig from "@/config/config.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import moment from "moment";

const Router = useRouter();
const route = useRoute();

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible", "handleUpgrade"]);
let subscription = null;
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  upgradeDialogData: {
    type: Object,
    default: () => ({}),
  },
  productList: {
    type: Array,
    default: () => [],
  },
  allowed_behavior: {
    type: Number,
    default: 0,
  },
});

const dialogVisible = ref(props.visible);
// const creditList = ref([])
const handleLoading = ref(false);

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

const mathCurPrice = () => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  const product = props.upgradeDialogData;
  if (product.new_product.channel == "paypal") {
    return `$ ${product?.cur_product?.price} / ${product?.cur_product?.period_name}`;
  }
  return `${product.cur_product.stripe_info.currency_symbol} ${formatter.format(product.cur_product.stripe_info.amount / 100)} / ${
    product?.cur_product?.period_name
  }`;
};

const mathNewPrice = () => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  const product = props.upgradeDialogData;
  if (product.new_product.channel == "paypal") {
    return `$ ${product?.new_product?.price} / ${product?.new_product?.period_name}`;
  }
  return `${product.new_product.stripe_info.currency_symbol} ${formatter.format(product.new_product.stripe_info.amount / 100)} / ${
    product?.new_product?.period_name
  }`;
};

// const getList = () => {
//   getProducts("stripe", {
//     category: "normal",
//   }).then((res) => {
//     if (res.code == 200) {
//       creditList.value = res?.data?.list || []
//     }
//   })
// }

const handleUpgrade = (product) => {
  handleLoading.value = true;
  emits("handleUpgrade", product);
};

const checkRenderPay = async () => {
  try {
    paypal = await loadScript({ clientId: GlobalConfig.paypalKey, vault: true });
  } catch (error) {
    console.error("failed to load the PayPal JS SDK script", error);
  }

  if (paypal) {
    try {
      await paypal
        .Buttons({
          style: {
            layout: "horizontal",
            color: "silver",
            // label: "paypal",
            borderRadius: 8,
            tagline: false,
          },
          createSubscription: async (payData, actions) => {
            const product_id = props.upgradeDialogData.new_product?.product_id;
            let plan_id;
            props.productList.forEach((element) => {
              if (product_id == element.paypal_info.product_id) {
                plan_id = element.paypal_info.plan_id;
              }
            });
            subscription = await actions.subscription.create({
              plan_id: plan_id, // Creates the subscription
              // custom_id: "sub_change",
            });

            const { code, data, msg } = await upgrade({
              new_product_id: product_id,
              action_type: props.allowed_behavior,
              paypal_subscription_id: subscription,
            });

            if (code == 200) {
              return subscription;
            } else if (code == 500) {
              message.error({
                content: "failed to switch plan, please try again later",
              });
            } else if (code == 8012) {
              message.error({
                content: "failed to switch plan, please try again later",
              });
            } else if (code == 8013) {
              message.error({
                content: "Failed to switch plan, please check your Stripe payment settings",
              });
            } else {
              message.error({
                content: msg,
              });
            }
          },
          onApprove: function (data, actions) {
            // alert("You have successfully subscribed to " + data.subscriptionID); // Optional message given to subscriber
            const product_id = props.upgradeDialogData.new_product?.product_id;
            Router.push({
              name: "paymetResult",
              query: {
                pay_channel: "paypal",
                product_id: product_id,
                subscription_id: subscription,
                from_type: route.query.from_type ?? "",
                source_route: route.query.source_route ?? "",
              },
            });
          },
        })
        .render("#paypal-button-container");
    } catch (error) {
      console.error("failed to render the PayPal Buttons", error);
    }
  }
};

onMounted(() => {
  if (props.upgradeDialogData.new_product.channel == "paypal") {
    checkRenderPay();
  }
});

onUnmounted(() => {
  handleLoading.value = false;
});
</script>

<style lang="scss" scoped>
.upgrade-dialog {
  .info-box {
    .info-item {
      .price {
        .discount-text {
          display: inline-block;
          text-decoration: line-through;
          margin-right: 15px;
        }
      }
    }
    .paypal-text {
      margin-bottom: 20px;
    }
    .paypal-button-box {
      padding-bottom: 25px;
    }
  }
}

.pc-upgrade-dialog {
  .title {
    padding: 0 40px;
    font-size: 22px;
    font-weight: 600;
    line-height: 22px;
    color: #fff;
    margin-bottom: 24px;
  }
  .info-box {
    padding: 0 40px;
    font-size: 18px;
    font-weight: normal;
    line-height: 24px;
    color: #fff;
    .info-item {
      margin-bottom: 12px;
      display: flex;
      align-items: top;
      justify-content: space-between;
      gap: 10px;
      &.big-text {
        font-size: 24px;
        margin-bottom: 24px;
        font-weight: bold;
      }
      .text {
        flex: 1;
      }
      .price {
      }
    }
    .Upgrade-button {
      background: linear-gradient(95deg, #4fdeff 0%, #e675ff 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      height: 48px;
      border-radius: 24px;
      margin-bottom: 40px;
      &.is-loading {
        .loading {
          display: block;
        }
        .common {
          display: none;
        }
      }
      .loading {
        display: none;
        height: 20px;
        width: 20px;
        min-width: 20px;
        min-height: 20px;
        background: transparent;
        background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
        background-size: 100% 100% !important;
        animation: animation-rotate-infinite 0.75s infinite normal linear;
        opacity: 1;
        visibility: visible;
        z-index: 1;
        svg {
          display: none;
        }
      }
    }
  }
  .line {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 24px;
    padding-top: 12px;
  }
  .time {
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 24px;
  }
}

.mobile-upgrade-dialog {
  .title {
    padding: 0 16px;
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    color: #fff;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .info-box {
    padding: 0 16px;
    font-size: 14px;
    font-weight: normal;
    color: #fff;
    .info-item {
      margin-bottom: 12px;
      display: flex;
      align-items: top;
      justify-content: space-between;
      gap: 24px;
      &.big-text {
        font-size: 20px;
        margin-bottom: 24px;
        font-weight: bold;
      }
      .text {
        flex: 1;
      }
      .price {
        // flex: 1;
      }
    }
    .Upgrade-button {
      background: linear-gradient(95deg, #4fdeff 0%, #e675ff 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      height: 48px;
      border-radius: 24px;
      margin-bottom: 30px;
      &.is-loading {
        .loading {
          display: block;
        }
        .common {
          display: none;
        }
      }
      .loading {
        display: none;
        height: 20px;
        width: 20px;
        min-width: 20px;
        min-height: 20px;
        background: transparent;
        background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
        background-size: 100% 100% !important;
        animation: animation-rotate-infinite 0.75s infinite normal linear;
        opacity: 1;
        visibility: visible;
        z-index: 1;
        svg {
          display: none;
        }
      }
    }
  }
  .line {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 24px;
    padding-top: 12px;
  }
  .time {
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 24px;
  }
}
</style>
